import { Image } from "@chakra-ui/react";
import useScreen from "../../../hooks/useScreen";

interface ShareOptionsButtonProps {
  showShareOptions: boolean;
  setShowShareOptions: (value: boolean) => void;
}

export const ShareOptionsButton = (props: ShareOptionsButtonProps) => {
  const { showShareOptions, setShowShareOptions } = props;
  const { isMobile } = useScreen();

  const handleOnClick = () => {
    setShowShareOptions(!showShareOptions);
  };

  return (
    <Image
      cursor={"pointer"}
      onClick={handleOnClick}
      src={process.env.PUBLIC_URL + "/assets/images/menu.svg"}
      height={isMobile ? "42px" : "52px"}
      width={isMobile ? "42px" : "52px"}
    />
  );
};
